import { backendGet } from "./Backend";

export interface CatalogSymbol {
  symbol: string;
  underlying_symbol: string;
  display: string;
  name: string;
  market: string;
  market_display: string;
  submarket: string;
  submarket_display: string;
  underlying_symbol_type: string | null;
  pip_size: number | null;
  decimals: number;
  exchange_is_open: boolean;
  is_trading_suspended: boolean;
}

export interface MarketGroup { market: string; display: string; submarkets: { submarket: string; display: string; symbols: string[] }[] }

const DEFAULT_SYMBOL = "1HZ50V";
let cache: { symbols: CatalogSymbol[]; markets: MarketGroup[] } | null = null;
let inflight: Promise<{ symbols: CatalogSymbol[]; markets: MarketGroup[] }> | null = null;
const listeners = new Set<(c: CatalogSymbol[]) => void>();

// DerivSymbolCatalog (browser side): populated from the backend's dynamic active_symbols discovery.
export const SymbolCatalog = {
  async load(force = false) {
    if (cache && !force) return cache;
    if (!inflight) {
      inflight = backendGet<{ symbols: CatalogSymbol[]; markets: MarketGroup[] }>("/market/symbols", force ? { refresh: 1 } : {}, 20000)
        .then((res) => { cache = { symbols: res.symbols || [], markets: res.markets || [] }; listeners.forEach((l) => l(cache!.symbols)); return cache; })
        .catch(() => cache ?? { symbols: [], markets: [] })
        .finally(() => { inflight = null; });
    }
    return inflight;
  },
  get(code: string): CatalogSymbol | undefined { return cache?.symbols.find((s) => s.symbol === code); },
  all(): CatalogSymbol[] { return cache?.symbols ?? []; },
  markets(): MarketGroup[] { return cache?.markets ?? []; },
  onLoad(cb: (c: CatalogSymbol[]) => void): () => void { listeners.add(cb); if (cache) cb(cache.symbols); return () => listeners.delete(cb); },
  async resolveDefault(): Promise<string> {
    const { symbols } = await this.load();
    const hit = symbols.find((s) => /volatility 50 \(1s\)/i.test(s.name));
    return hit?.symbol ?? DEFAULT_SYMBOL;
  },
};
